import {
  PLAYGROUND_ACCEPTED_FILE_TYPES,
  PLAYGROUND_MAX_FILE_SIZE_BYTES,
} from "src/base-components/agents/playgroundFileConstants";
import { AcceptedFileTypes, FileSource } from "src/utils/files";

// Chat attachments ride the same agent-runner harness as playground files
// (AGNT-959), so the accepted formats and size cap are aliased rather than
// redefined — diverge here if the copilot ever needs its own policy.
export const COPILOT_CHAT_ACCEPTED_FILE_TYPES: AcceptedFileTypes =
  PLAYGROUND_ACCEPTED_FILE_TYPES;

export const COPILOT_CHAT_MAX_FILE_SIZE_BYTES = PLAYGROUND_MAX_FILE_SIZE_BYTES;

// The copilot API rejects messages with more than 20 file blocks (422).
export const MAX_COPILOT_CHAT_ATTACHMENTS = 20;

export const COPILOT_FILE_SOURCE: FileSource = "copilot";
